var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}]},[_vm._t("default"),(!_vm.categoriesRegistered)?_c('div',{staticClass:"hidden"},[_vm._t("categories")],2):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }